/* Observership external application: Forgot Password page (initiated from Login page)
 * 
 * Page will display success/fail message for sending reset password email
 * User will receive email to reset password
 
 * author: @ch168189
 * created: 08/31/2023
 
 */
 
 import React, {useState,  useRef,  useContext, useEffect} from "react";  
 import { useLocation} from 'react-router-dom';
 import ReCAPTCHA from "react-google-recaptcha";
 import {  Formik} from "formik";  
 import InputTxt from "../framework/InputTxt";
 import Button from "../framework/Button";
 //import Ribbon from "../framework/Ribbon";
 import Ribbon from "../framework/Ribbon";
 
 import webRootContext from "../components/webrootcontext/WebRootContext";
 import {User_PasswordReset_Object} from "../components/UserPasswordResetObject";
 import { AppConfiguration } from "../framework/AppConfigProvider";

 function ForgotPassword()  {

    const localConfig = useContext(AppConfiguration);
    const location = useLocation();  
    const forcedPwd = location.state; 
    const [verifiedUser, setVerifiedUser] = useState(true);
     
    const [userResetPwdWarning, setUsesrResetPwdWarning] = useState(false); 
    const usernotfound = "We could not find an account with that email address";
    
    const usesrResetPwdWarningMsgContent = <div>
    		<div className="H2_Subheader">New Observership Program Portal</div>
              
        	<div>We recently launched a new Observership Program Portal which provides you with added security 
        	and ease-of-use. Please <a href="./ForgotPassword"><b>reset your password</b></a> to access the new portal.</div>
    	</div>; 
    
	const [answerConfirmed,  setAnswerConfirmed] = useState();
	const [securityQuestionFormObject, setSecurityQuestionFormObject] = useState(User_PasswordReset_Object);
	
	
	const [userSubmitted, setUserSubmitted] = useState();
	const [formikError, setFormikError] = useState();
	const [formSubmitted, setFormSubmitted] = useState();
	const [responseError, setResponseError] = useState("");
	const captchaRef = useRef(null);
	const formRef = useRef(null); 
	const verifyRecaptcha_api_url =  webRootContext + "/rest/captchaservice/verifyCaptcha";
	
			    
	const formSuccessMsgContent =  <div>	               			    										
					 	Please check your inbox and follow the instructions to reset your password.
					</div>;
	const formErrMsgTitle = <div>Sorry, there was a problem.</div>;
			
				          
	const generalErrMsgContent =  <div>
					<div className="padding-bottom-30"> 
						Please contact the Observership Program (observership.program@childrens.harvard.edu)
				     </div>
	           </div>; 
	             
	const emailErrMsgContent =  <div>
					<div className="padding-bottom-30"> 
					    Unable to send the reset password email.
				     </div>
	           </div>; 
	                      
	const [errMsgContent,setErrMsgContent] = useState(generalErrMsgContent);
	
    const checkKeyDown = (e) => {
        if (e.key === 'Enter') e.preventDefault();
    }	                   
	
	window.recaptchaOptions = {
	  useRecaptchaNet: true
	  
	};

	let captChaContent=<div></div>;
	if(localConfig.configProperties.captchaSiteKey!=null){
	  captChaContent = <ReCAPTCHA sitekey={localConfig.configProperties.captchaSiteKey}  ref={captchaRef}  />		
	}	
    
	function validateEmail(checkemail){
		let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/; // eslint-disable-line

		return reg.test(checkemail.trim());
	}
	
	function ConfirmSecurityQuestion(setFieldError ){
       
         if (!securityQuestionFormObject.securityAns || securityQuestionFormObject.securityAns.trim().length === 0) {
             SetAnswerFieldError(setFieldError, 'Security answer is required');
             return;
          }
        
        let url = webRootContext + "/rest/usermanagement/confirmSecurityQuestion";
        fetch(url, {
	      	method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			body: JSON.stringify(securityQuestionFormObject),
			mode:"cors"})
			.then((response) => {
                 if (response.ok) {
                         
	                     return response.text();                              					      					       					 
                 }else{    
                        setResponseError("There was an error retrieving the security answer.");
      					 setFormikError(true);	
      					       
	                     return null;
                 }	
            })
         	.then((result) => {		
                    	    
				    if(result === '1'){
                        
                      setFormSubmitted(true);
                      setAnswerConfirmed(true); 
                      
                    }else if (result === '-2'){
                        setErrMsgContent(emailErrMsgContent);
                        setFormSubmitted(true);
                         setAnswerConfirmed(false); //handle error message for email sending failure
                         
                    }
                    else{
                      
                      setFormSubmitted(false);
                      setAnswerConfirmed(false); 
                      
                      SetAnswerFieldError(setFieldError, 'The security answer is incorrect');
             
                   }
                   console.log("test email sending error:",  errMsgContent);
             });
          
    }
    
    function SetAnswerFieldError(setFieldError, errMsg){
         setResponseError("REVIEW ISSUES BELOW");  
		  setTimeout(function(){ //timeout is needed!
		    setFieldError('securityQuestionAnswer', errMsg);	 
		  }, 10);  
        
    }
    
	function submitFormWithCaptchaToken(userEmail){    
           if(!verifiedUser) {
              return;	 
           } 
           
        
	        const token = captchaRef.current.getValue();				  	
	        captchaRef.current.reset();	
	          				
	        if(token == null  || token === ""){
	            setFormSubmitted(false); 
				setResponseError("Please check Captcha checkbox ");
				
				return;
	        }
			
				
			 fetch(verifyRecaptcha_api_url, {
		      	method: 'POST', 
		   		headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
						},
				body: token,
		    	mode:"cors"})
	 		    .then((response) => {
					 return response.status;			  
			    })
			    .then((result) => {
				    
				    if(result === 200){
	                  
	                   setUserSubmitted(true);  
	                   
	                   RetrieveSecurityQuestion(userEmail);
	                   setUsesrResetPwdWarning(false);
	                     
				   }else{
					 
					  setUserSubmitted(false);
				   }
				   
				  
			  });
		  
		  
		   
	}
	
	
   function RetrieveSecurityQuestion(userEmail){
       console.log("retrieving security question : ", userEmail);	
       let retrieveSecurityQuestion_api_url = webRootContext + "/rest/usermanagement/retrieveSecurityQuestion";
       
       fetch(retrieveSecurityQuestion_api_url, {
		      	method: 'POST', 
		   		headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json'
						},
				body: userEmail.trim(),
		    	mode:"cors"})
	 		    .then((response) => {
                     
                     if (response.ok) {
	                     return response.json();                              					      					       					 
	                 }else{    
                         setResponseError("There was an error retrieving the security question.");
      					 setFormikError(true);	
      					       
	                     return null;
	                 }								  
			    })
			    .then((result) => {
				    console.log("response :", result);
				    if(result !== null && result.securityQst !== ""){
	                   setFormikError(false);		
	                   setSecurityQuestionFormObject({...securityQuestionFormObject, id:result.id, questionId: result.questionId, securityQst: result.securityQst});                  	                     
				   }
				   
				  
			  });
        
      
   } 
   
   
    
	function VerifyUserByEmail(userEmail, setFieldError) {
        
        if (!userEmail || userEmail.trim().length === 0) {
			setFieldError('userEmail', 'Email address is required');	
			return;		           
		} 
		
		if (userEmail && (!validateEmail(userEmail))){
			setFieldError('userEmail', 'Enter a valid email address using this format: example@mail.com');  
			return;
		}
       
        let url = webRootContext + "/rest/usermanagement/verifyUserByEmail";
         fetch(url, {
	      	method: 'POST', 
	   		headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
					},
			body: userEmail.trim(),
	    	mode:"cors"})
 		    .then((response) => {
                 if (response.ok) {
                     return response.json();
                 }else{
                   
                     return null
                 }						  
		    })
		    .then(
                (result) => {
                    
                    if(result === 0){ 
                        setVerifiedUser(false);
                        setResponseError("REVIEW ISSUES BELOW");
                        setFormikError(true);		
                        
                        setFieldError('userEmail', usernotfound);	 
                    }else{
                        setVerifiedUser(true);
                        setResponseError("");
                        setFormikError(false);
                        setFieldError('userEmail', "");	
                    } 
                    
                    
                                       
                }
            )
		    .catch((err) => {
                
          		console.log("api error", err); 
	  		});
        
    }
	
	useEffect(() => {	
        //console.log("forced pwd reset:", forcedPwd);
        if(forcedPwd !== undefined && forcedPwd.data === "FORCEPWD") {
        	setUsesrResetPwdWarning(true);
        }
    
        const footerElement = document.querySelector('.footer');
        if (footerElement) {
            footerElement.classList.add("footer_extra")
        }
        
        return () => {
          if (footerElement) {
            footerElement.classList.remove('footer_extra');
          }
        }
    },[]);// eslint-disable-line
	
	return (
        <div id="forgotpassword" >
       		  <Formik innerref={formRef} 
			 	initialValues={{	
				 	userEmail: "",
				 	securityQuestionAnswer: ""
				 }}
				validateOnChange={false}
			 	validate={values => {
					 const errors = {};		 
							         
			         if(userSubmitted){
                         
                          if (!values.securityQuestionAnswer || values.securityQuestionAnswer.trim().length === 0) {
					           errors.securityQuestionAnswer= 'Security answer is required';			           
					         } 
                     }else{
         
                         if (!values.userEmail || values.userEmail.trim().length === 0) {
				           errors.userEmail = 'Email address is required';			           
				         } 
				         
				         if (values.userEmail && (!validateEmail(values.userEmail))){
							errors.userEmail = "Enter a valid email address using this format: example@mail.com";  
						 }
						  
				          
			         
                         
                     }			         
			         			         					 
						   		          
			         if( Object.keys(errors).length > 0) {
						setFormikError(true);
						setResponseError("REVIEW ISSUES BELOW");
					  } else {
                          if(verifiedUser){
                             setFormikError(false);
			              	setResponseError("");
                          }else{                            
                              errors.userEmail = usernotfound;
                              setFormikError(true);
						      setResponseError("REVIEW ISSUES BELOW");
                          }
			              
			          }	
	          
	                 console.log("error ",  errors);
			         return errors;
		       }}
			 
			 onSubmit={(values,   { setSubmitting}) => {
						
		          setTimeout(() => {          				
          				
          						  	                       
		          		submitFormWithCaptchaToken(values.userEmail);
		          		
                        setSubmitting(false);  
		            	                            		          	    		          		
		          }, 100);
		        }}			 
			 >
			 
			   { ({
		          values /* all data need to run the valdation*/,
		          errors /* all error strings */,
		          touched/* all field touch event  */,
		          handleChange   /* value change event handler */,
		          handleBlur /* onBlur event handler */,
		          handleSubmit /* for submit button */,
		          setFieldError,
		          isSubmitting /* for submit button */,
		          isValid /* for submit button */,
		          dirty /* for submit button */,
		          validateForm
		          /* and other goodies */
		        }) => (
				
				 <form onSubmit={handleSubmit} onKeyDown={(e) => checkKeyDown(e)} noValidate>
				 
				     <div id="resetMsg" className={(userResetPwdWarning ? 'show_div' : 'hide_div')}>
							<div id="resetMsgDiv" className="div_1_col">
								<Ribbon label={"RESET PASSWORD"} status={"attention"} subheader={""}  content={usesrResetPwdWarningMsgContent} />
							</div>
					 </div>   
			
				      <div id="submitResult" className={(formSubmitted ? 'show_div' : 'hide_div')}>
						<div id="resultDiv" className="div_3_col">
							<Ribbon label={answerConfirmed? "Thank you": "error"} status={answerConfirmed? "checkmark": "error"} subheader={answerConfirmed? formSuccessMsgContent : formErrMsgTitle} content={answerConfirmed? "" : errMsgContent} />
						</div>						
				   </div>	
				   
				    <div id="formikErrors" className={(formikError || responseError !== "" ? 'show_div' : 'hide_div')}>
		               <div id="formikFailDiv" className="div_1_col">
		               		<Ribbon label={responseError} status={"error"} subheader={""} content={""} />
		               </div>
		          </div>
				   
				     <div id="theDiv2Hide5" className={(formSubmitted ? 'hide_div' : 'show_div div_3_col')}>
				          	<div className="breadcrumbLink">
				                <a href="/observership/Login">Login</a>
				            </div>         
				            <div className={(userSubmitted === true?'hide_div':'show_div' ) + " page_title" }> Reset/Forgot Password</div> 
				            <div className={(userSubmitted === true?'show_div':'hide_div' ) + " page_title" }> Answer Security Question</div>            
			           </div>
           		   
				   
				 		 
				  	 
				 		 
		 		  <div id="userInputs" className={(userSubmitted === true?'hide_div':'show_div' )} >
		 		  	<div className="div_3_col padding-bottom-30"></div>
				 		 			 	
				 	<div className="div_3_col">
					 	<InputTxt
			                id="userEmail" 
			                name="userEmail" 
			                labelText="Email address"      
			                isRequired={true} 
			                maxLength={100}
			                noSpace={true}
			                errorMessage={errors.userEmail}         
			                hasError={touched.userEmail && errors.userEmail}                               
			                onChange={handleChange}		               
			                onBlur={(e) => {handleBlur(e); 			                                               
			                                VerifyUserByEmail(e.target.value,setFieldError);} }          
			              />
		             </div>		 	
		             
		             <hr className="hr--light" />
		             
		             <div className="div_3_col padding-bottom-30">
		             	{captChaContent}		              
		             </div>
		             
		            
		             <div className="div_3_col">	             
			             <Button
			                text={"Continue"}
			                styleName={"button button--primary"}
			                type="button"
			                id={"button_continue"}
			                onClick={ (e) =>{ validateForm();  }}
			              />		              		               		                            
		            </div>
	             </div>
		            
	            <div id="securityInputs" className={(userSubmitted && (!formSubmitted)  && (!answerConfirmed)  === true?'show_div':'hide_div' )} >
	               <div className="div_3_col padding-bottom-30"></div>
	               
		             
	               <div className="div_3_col">
					 	<InputTxt
			                id="securityQuestionAnswer" 
			                name="securityQuestionAnswer" 
			                labelText={securityQuestionFormObject.securityQst}
			                isRequired={true} 
			                errorMessage={errors.securityQuestionAnswer}         
			                maxLength={100}
			                hasError={touched.securityQuestionAnswer && errors.securityQuestionAnswer}                               
			                onChange={handleChange}		               
			                onBlur={handleBlur } 
			                getTextString={(securityQuestionAnswer) =>setSecurityQuestionFormObject({...securityQuestionFormObject, securityAns:securityQuestionAnswer.trim()})}            
			              />
		             </div>	
		             
		             
		            <div className="div_3_col">
			            <Button
			                text={"submit security answer"}
			                styleName={"button button--primary"}
			                id={"button_submit"}
			                type="button"
			                onClick={(e) =>{ ConfirmSecurityQuestion(setFieldError); e.preventDefault(); }}
			              />		            
		            </div>		            	
	            </div>
		 		  
		 		 				 			            		             				 	
		        </form>
				 
				 
				 )}
		 </Formik>
       </div>
    )
    };

export default ForgotPassword;